/**
 * Portal login / register password rules.
 * Single source of truth — keep in sync with pswValidatePopover UI.
 */
export const PORTAL_PASSWORD_LENGTH = /^.{12,15}$/
export const PORTAL_PASSWORD_UPPER = /(?=.*?[A-Z])/
export const PORTAL_PASSWORD_LOWER = /(?=.*?[a-z])/
/** Digit + special char (charset matches pswValidatePopover rule4). */
export const PORTAL_PASSWORD_DIGIT_AND_SPECIAL =
  /(?=.*?[0-9])(?=.*?[#?!@_$%^&*-.])/

/**
 * @param {string} psw
 * @returns {boolean}
 */
export function testPortalPassword(psw) {
  if (psw == null || psw === '') return false
  return (
    PORTAL_PASSWORD_LENGTH.test(psw) &&
    PORTAL_PASSWORD_UPPER.test(psw) &&
    PORTAL_PASSWORD_LOWER.test(psw) &&
    PORTAL_PASSWORD_DIGIT_AND_SPECIAL.test(psw)
  )
}
